import { api } from "../api/index.ts";

const doUploadPersonData = api.path("/api/personData").method("post").create();

export async function uploadPersonData(
	imageData: string | undefined,
	audioData: string | undefined,
	token: string,
): Promise<{ imageFile: string | undefined; audioFile: string | undefined }> {
	if (!imageData && !audioData) {
		return { imageFile: undefined, audioFile: undefined };
	}
	const response = await doUploadPersonData(
		{ imageData, audioData },
		{ headers: { authorization: `Bearer ${token}` } },
	);
	const data = response.data as {
		imageFile?: string;
		audioFile?: string;
	};
	return {
		imageFile: data.imageFile,
		audioFile: data.audioFile,
	};
}
